import DevBuddy from 'devbuddy'
import { assignGlobal } from '~/global'

if (process.env.NODE_ENV === 'development') {
  assignGlobal({DevBuddy})
}